(() => {
  const STYLE_ID = 'lamseti-mobile-menu-tree-styles';

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media (max-width: 989px) {
        body.lamseti-mobile-menu-open { overflow: hidden; }
        .lamseti-mega-header .kh-mobile-panel > a { display: none; }
        .lamseti-mega-header .kh-mobile-tree { display: flex; flex-direction: column; gap: 8px; }
        .lamseti-mega-header .kh-mobile-tree > a,
        .lamseti-mega-header .kh-mobile-branch {
          border: 1px solid color-mix(in srgb, var(--kh-border) 62%, transparent);
          border-radius: 11px;
          background: color-mix(in srgb, var(--kh-bg) 55%, transparent);
          overflow: hidden;
        }
        .lamseti-mega-header .kh-mobile-tree > a,
        .lamseti-mega-header .kh-mobile-branch > summary {
          min-height: 52px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 12px 14px;
          border: 0;
          color: var(--kh-text);
          background: transparent;
          font-size: 14px;
          font-weight: 700;
          text-decoration: none;
          list-style: none;
          cursor: pointer;
        }
        .lamseti-mega-header .kh-mobile-branch > summary::-webkit-details-marker { display: none; }
        .lamseti-mega-header .kh-mobile-branch > summary::after {
          content: '';
          width: 8px;
          height: 8px;
          flex: 0 0 auto;
          border-right: 1.5px solid currentColor;
          border-bottom: 1.5px solid currentColor;
          transform: rotate(45deg);
          transition: transform .18s ease, color .18s ease;
          opacity: .72;
        }
        .lamseti-mega-header .kh-mobile-branch[open] {
          border-color: color-mix(in srgb, var(--kh-accent) 46%, var(--kh-border));
          background: color-mix(in srgb, var(--kh-surface) 94%, transparent);
        }
        .lamseti-mega-header .kh-mobile-branch[open] > summary {
          color: var(--kh-accent);
          background: color-mix(in srgb, var(--kh-accent) 9%, transparent);
          border-bottom: 1px solid color-mix(in srgb, var(--kh-border) 55%, transparent);
        }
        .lamseti-mega-header .kh-mobile-branch[open] > summary::after { transform: rotate(225deg); }
        .lamseti-mega-header .kh-mobile-submenu { padding: 10px 10px 12px; }
        .lamseti-mega-header .kh-mobile-shop-all {
          min-height: 42px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          padding: 9px 11px;
          border: 1px solid color-mix(in srgb, var(--kh-accent) 42%, transparent);
          border-radius: 9px;
          background: color-mix(in srgb, var(--kh-accent) 11%, transparent);
          color: var(--kh-accent) !important;
          font-size: 12px;
          font-weight: 750 !important;
          text-decoration: none;
        }
        .lamseti-mega-header .kh-mobile-shop-all::after { content: '→'; font-size: 15px; }
        .lamseti-mega-header .kh-mobile-category {
          margin-top: 9px;
          padding: 11px;
          border: 1px solid color-mix(in srgb, var(--kh-border) 48%, transparent);
          border-radius: 10px;
          background: color-mix(in srgb, var(--kh-bg) 45%, transparent);
        }
        .lamseti-mega-header .kh-mobile-category__title {
          min-height: 34px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          padding: 0 2px 9px;
          border-bottom: 1px solid color-mix(in srgb, var(--kh-border) 46%, transparent);
          color: var(--kh-text);
          font-size: 12px;
          font-weight: 800;
          letter-spacing: .025em;
          text-decoration: none;
        }
        .lamseti-mega-header .kh-mobile-category__title::after {
          content: 'View all';
          color: var(--kh-accent);
          font-size: 9px;
          font-weight: 700;
          letter-spacing: .02em;
        }
        .lamseti-mega-header .kh-mobile-level3 {
          display: grid;
          grid-template-columns: 1fr;
          gap: 6px;
          padding-top: 9px;
        }
        .lamseti-mega-header .kh-mobile-level3 a {
          min-height: 39px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          padding: 8px 10px;
          border: 1px solid color-mix(in srgb, var(--kh-border) 35%, transparent);
          border-radius: 8px;
          background: color-mix(in srgb, var(--kh-surface) 70%, transparent);
          color: color-mix(in srgb, var(--kh-text) 86%, transparent);
          font-size: 12px;
          font-weight: 550;
          line-height: 1.3;
          text-decoration: none;
          transition: color .18s ease, border-color .18s ease, background-color .18s ease, transform .18s ease;
        }
        .lamseti-mega-header .kh-mobile-level3 a::after {
          content: '›';
          flex: 0 0 auto;
          color: var(--kh-accent);
          font-size: 17px;
          line-height: 1;
        }
        .lamseti-mega-header .kh-mobile-level3 a:hover,
        .lamseti-mega-header .kh-mobile-level3 a:focus-visible {
          color: var(--kh-accent);
          border-color: color-mix(in srgb, var(--kh-accent) 48%, transparent);
          background: color-mix(in srgb, var(--kh-accent) 9%, transparent);
          transform: translateX(2px);
          outline: none;
        }
        .lamseti-mega-header .kh-mobile-tree > a:hover,
        .lamseti-mega-header .kh-mobile-tree > a:focus-visible,
        .lamseti-mega-header .kh-mobile-branch > summary:hover,
        .lamseti-mega-header .kh-mobile-branch > summary:focus-visible,
        .lamseti-mega-header .kh-mobile-category__title:hover,
        .lamseti-mega-header .kh-mobile-category__title:focus-visible {
          color: var(--kh-accent);
          outline: none;
        }
      }

      @media (min-width: 600px) and (max-width: 989px) {
        .lamseti-mega-header .kh-mobile-level3 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
      }
    `;
    document.head.appendChild(style);
  };

  const copyLink = (source, className = '') => {
    const link = document.createElement('a');
    link.href = source.href;
    link.textContent = source.textContent.trim();
    if (className) link.className = className;
    if (source.getAttribute('aria-current')) link.setAttribute('aria-current', source.getAttribute('aria-current'));
    return link;
  };

  const buildCategoryGroup = (column) => {
    const titleLink = column.querySelector(':scope > .kh-mega__title');
    if (!titleLink) return null;

    const level3Links = [...column.querySelectorAll(':scope > a')].filter((link) => {
      return link !== titleLink && !link.classList.contains('kh-mega__all');
    });

    if (!level3Links.length) return copyLink(titleLink);

    const category = document.createElement('section');
    category.className = 'kh-mobile-category';

    const title = copyLink(titleLink, 'kh-mobile-category__title');
    category.appendChild(title);

    const level3 = document.createElement('div');
    level3.className = 'kh-mobile-level3';
    level3Links.forEach((link) => level3.appendChild(copyLink(link)));
    category.appendChild(level3);

    return category;
  };

  const buildMobileTree = (header) => {
    const mobileMenu = header.querySelector('.kh-mobile-menu');
    const panel = mobileMenu?.querySelector('.kh-mobile-panel');
    const nav = header.querySelector('.kh-nav');
    if (!mobileMenu || !panel || !nav || panel.dataset.lamsetiEnhanced === 'true') return;

    const tree = document.createElement('div');
    tree.className = 'kh-mobile-tree';

    [...nav.querySelectorAll(':scope > .kh-nav-item')].forEach((item) => {
      const topLink = item.querySelector(':scope > a');
      const mega = item.querySelector(':scope > .kh-mega');
      if (!topLink) return;

      if (!mega) {
        tree.appendChild(copyLink(topLink));
        return;
      }

      const details = document.createElement('details');
      details.className = 'kh-mobile-branch';

      const summary = document.createElement('summary');
      summary.textContent = topLink.textContent.trim();
      details.appendChild(summary);

      const submenu = document.createElement('div');
      submenu.className = 'kh-mobile-submenu';

      const topShopAll = copyLink(topLink, 'kh-mobile-shop-all');
      topShopAll.textContent = `Shop all ${topLink.textContent.trim()}`;
      submenu.appendChild(topShopAll);

      mega.querySelectorAll('.kh-mega__column').forEach((column) => {
        const category = buildCategoryGroup(column);
        if (category) submenu.appendChild(category);
      });

      details.appendChild(submenu);
      tree.appendChild(details);

      details.addEventListener('toggle', () => {
        if (!details.open) return;
        tree.querySelectorAll('.kh-mobile-branch[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });

    panel.appendChild(tree);
    panel.dataset.lamsetiEnhanced = 'true';

    const syncOpenState = () => {
      document.body.classList.toggle('lamseti-mobile-menu-open', mobileMenu.open);
      mobileMenu.setAttribute('aria-expanded', mobileMenu.open ? 'true' : 'false');
    };

    mobileMenu.addEventListener('toggle', syncOpenState);
    syncOpenState();

    panel.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        mobileMenu.open = false;
        syncOpenState();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileMenu.open) {
        mobileMenu.open = false;
        syncOpenState();
        mobileMenu.querySelector(':scope > summary')?.focus();
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (!mobileMenu.open) return;
      const target = event.target;
      const summary = mobileMenu.querySelector(':scope > summary');
      if (!panel.contains(target) && !summary?.contains(target)) {
        mobileMenu.open = false;
        syncOpenState();
      }
    });
  };

  const init = (root = document) => {
    ensureStyles();
    root.querySelectorAll?.('.lamseti-mega-header').forEach(buildMobileTree);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
